export default __webpack_public_path__ + "static/media/deer.58d93a8e.png";